import { render, staticRenderFns } from "./PresalesDailyChart.vue?vue&type=template&id=03875c10&scoped=true&"
import script from "./PresalesDailyChart.vue?vue&type=script&lang=js&"
export * from "./PresalesDailyChart.vue?vue&type=script&lang=js&"
import style0 from "./PresalesDailyChart.vue?vue&type=style&index=0&id=03875c10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03875c10",
  null
  
)

export default component.exports